import { render } from "./FuneralInvitationPage.vue?vue&type=template&id=3d255e31"
import script from "./FuneralInvitationPage.vue?vue&type=script&lang=js"
export * from "./FuneralInvitationPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__